import type React from "react";

import { useTodoVM } from "../TodoVMContext.tsx";
import { Queryable } from "./Queryable.tsx";

export const Footer: React.FC = () => {
  const vm = useTodoVM();
  return (
    <footer data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:9:13" data-name="footer" className="footer">
      <span data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:10:13" data-name="span" className="todo-count">
        <Queryable query={vm.footer.incompleteDisplayText$} />
      </span>
      <ul data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:13:11" data-name="ul" className="filters">
        <Queryable query={vm.footer.currentFilter$}>
          {(filter) => (
            <>
              <li data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:17:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:18:30" data-name="a" className={filter === "all" ? "selected" : ""} onClick={vm.footer.showAll}>
                  All
                </a>
              </li>
              <li data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:22:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:23:30" data-name="a" className={filter === "active" ? "selected" : ""} onClick={vm.footer.showActive}>
                  Active
                </a>
              </li>
              <li data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:27:19" data-name="li">
                <a href="#/" data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:28:30" data-name="a" className={filter === "completed" ? "selected" : ""} onClick={vm.footer.showCompleted}>
                  Completed
                </a>
              </li>
            </>
          )}
        </Queryable>
      </ul>
      <button type="button" data-loc="phosphor-blog/content/_sources/view-model-interfaces/todo-vm/components/Footer.tsx:36:29" data-name="button" className="clear-completed" onClick={vm.footer.clearCompleted}>
        Clear completed
      </button>
    </footer>
  );
};
